import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import Hero from './components/Hero';
import LatestUpdates from './components/LatestUpdates';
import SolutionMosaic from './components/SolutionMosaic';
import ProductShowcase from './components/ProductShowcase';
import EpinSpotlight from './components/EpinSpotlight';
import LaunchZero from './components/LaunchZero';
import Partners from './components/Partners';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <SEO
        title="华辉数智技术 | 人工智能应用服务 · 乡村数字经济 · 县域数字商业基础设施"
        description="华辉数智技术是人工智能应用服务商，以TOMA智能体、数字货架、ePin数字身份等技术参与建设九畴云铺乡村数字经济操作系统，助力县域商业数字化与乡村振兴。"
        keywords="华辉数智技术,九畴云铺,人工智能应用服务,乡村数字经济,县域商业,数字基础设施,乡村振兴"
        path="/"
        jsonLd={[
          {
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '华辉数智技术',
            alternateName: 'HUAHUI DIGITAL INTELLIGENCE',
            url: 'https://www.huahui-digital.com/',
            description: '面向县域与乡村场景的人工智能应用服务与数字商业基础设施服务商。',
            areaServed: '中国',
            knowsAbout: ['人工智能应用服务', '乡村数字经济', '县域数字商业基础设施'],
          },
          {
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '华辉数智技术',
            alternateName: 'HUAHUI DIGITAL INTELLIGENCE',
            url: 'https://www.huahui-digital.com/',
            description: '人工智能应用服务 · 乡村数字经济 · 县域数字商业基础设施',
          },
        ]}
      />
      <main>
        <Hero />
        <LatestUpdates />
        <SolutionMosaic />
        <ProductShowcase />
        <EpinSpotlight />
        <LaunchZero />
        <Partners />
      </main>
      <Footer />
    </div>
  );
}